import * as React from 'react';
import { SVGProps } from 'react';

const SvgStatusSuccess = (props: SVGProps<SVGSVGElement>) => (
  <svg width={80} height={81} viewBox="0 0 80 81" fill="none" role="img" {...props}>
    <circle cx={40} cy={40} r={40} fill="#EDF7F1" />
    <rect x={8} y={8} width={64} height={64} rx={32} fill="#fff" />
    <mask id="a" fill="#fff">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M40 72c17.673 0 32-14.327 32-32C72 22.327 57.673 8 40 8 22.327 8 8 22.327 8 40c0 17.673 14.327 32 32 32Zm13.076-38.955a1.5 1.5 0 1 0-2.152-2.09L35.5 46.846l-6.424-6.618a1.5 1.5 0 0 0-2.152 2.09l7.5 7.727a1.5 1.5 0 0 0 2.152 0l16.5-17Z"
      />
    </mask>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M40 72c17.673 0 32-14.327 32-32C72 22.327 57.673 8 40 8 22.327 8 8 22.327 8 40c0 17.673 14.327 32 32 32Zm13.076-38.955a1.5 1.5 0 1 0-2.152-2.09L35.5 46.846l-6.424-6.618a1.5 1.5 0 0 0-2.152 2.09l7.5 7.727a1.5 1.5 0 0 0 2.152 0l16.5-17Z"
      fill="#6BC796"
    />
    <path
      d="m53.076 33.045-1.435-1.393 1.435 1.393Zm-2.152-2.09-1.435-1.393 1.435 1.393ZM35.5 46.846l-1.435 1.393 1.435 1.479 1.435-1.479-1.435-1.393Zm-6.424-6.618-1.435 1.393 1.435-1.393Zm-2.152 2.09-1.436 1.392 1.436-1.393Zm7.5 7.727-1.435 1.393 1.435-1.393Zm2.152 0 1.435 1.393-1.435-1.393ZM70 40c0 16.569-13.431 30-30 30v4c18.778 0 34-15.222 34-34h-4ZM40 10c16.569 0 30 13.431 30 30h4C74 21.222 58.778 6 40 6v4ZM10 40c0-16.569 13.431-30 30-30V6C21.222 6 6 21.222 6 40h4Zm30 30c-16.569 0-30-13.431-30-30H6c0 18.778 15.222 34 34 34v-4Zm11.652-37.641a.5.5 0 0 1-.01-.707l2.87 2.786a3.5 3.5 0 0 0-.074-4.95l-2.786 2.87Zm.707-.01a.5.5 0 0 1-.707.01l2.786-2.87a3.5 3.5 0 0 0-4.95.073l2.87 2.786Zm-15.424 15.89L52.36 32.35l-2.87-2.787-15.424 15.891 2.87 2.786Zm-9.294-6.618 6.424 6.618 2.87-2.786-6.424-6.618-2.87 2.786Zm.707.01a.5.5 0 0 1-.707-.01l2.87-2.786a3.5 3.5 0 0 0-4.949-.074l2.786 2.87Zm.01-.706a.5.5 0 0 1-.01.707l-2.786-2.87a3.5 3.5 0 0 0-.074 4.948l2.87-2.785Zm7.5 7.727-7.5-7.727-2.87 2.785 7.5 7.728 2.87-2.786ZM35.5 48.5a.5.5 0 0 1 .359.152l-2.87 2.786A3.5 3.5 0 0 0 35.5 52.5v-4Zm-.359.152a.5.5 0 0 1 .359-.152v4a3.5 3.5 0 0 0 2.511-1.062l-2.87-2.786Zm16.5-17-16.5 17 2.87 2.786 16.5-17-2.87-2.786Z"
      fill="#fff"
      mask="url(#a)"
    />
  </svg>
);

export default SvgStatusSuccess;
